import React, {useContext} from "react"
import {RouteDetailContext} from "./context/RouteDetailContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Column from "@amzn/meridian/column";
import CartContentV2 from "./CartContentV2";
import {NOT_IN_CART} from "../util/Constants";
import {FormattedMessage} from "react-intl";
import {getStationCode} from "../network/NetworkUtil";
import {getFCLMLink} from "../util/Util";

const PicklistContent = () => {
    const {viewModelRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)

    let containers = viewModelRD.picklistContainers[viewModelRD.selectedPicklist];
    containers = Array.isArray(containers) ? containers : [];

    const picklist = viewModelRD.picklists
        .filter(picklist => picklist.picklistId === viewModelRD.selectedPicklist)[0];

    const getCartCount = () => {
        return containers.filter(cart => cart.name !== NOT_IN_CART).length;
    }

    const stationCode = getStationCode()
    return (
        <Column width="100%">
            {picklist ?
                <Row width="100%" backgroundColor={"secondary"} spacingInset={"small"} spacing={"xlarge"}>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.status" defaultMessage="Status"/>:
                        </Text>
                        <Text type="b200">{picklist.status}</Text>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.progress" defaultMessage="Progress"/>:
                        </Text>
                        <Text type="b200">{picklist.pickProgress}</Text>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.associate" defaultMessage="Associate"/>:
                        </Text>
                        <Link key={picklist.picker} href={getFCLMLink(picklist.picker, configViewModel.stationConfig.fclmLinkEnabled, stationCode)} type="secondary"
                              target="_blank" rel="noreferrer noopener">
                            {picklist.picker}
                        </Link>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.carts" defaultMessage="Carts"/>:
                        </Text>
                        <Text type="b200">{getCartCount()}</Text>
                    </Row>
                </Row>
                : null
            }

            <Column width="100%">
                {containers.map((container, index) => {
                    return <CartContentV2 key={container.name} index={index} container={container} picklist={picklist}/>
                })}
            </Column>
        </Column>
    )
}

export default PicklistContent


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/PicklistContent.js